import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import FacilityTop from "./FacilityTop";
import { SearchState } from "../SearchModal";

import {
  useGetFacility,
  useGetRecommendFacilities,
} from "../../../utils/useFacility";
import { useMetaData } from "../../../utils/useMetaData";

const FacilityTopContainer: React.FC = () => {
  const navigate = useNavigate();

  const {
    items: { facilities },
    isLoading,
  } = useGetFacility({
    per: 3,
    sort_by: "_id",
    desc: true,
  });

  const {
    items: { entries: recommendData, sentence: sentenceData },
    isLoading: isRecommendLoading,
  } = useGetRecommendFacilities();

  const [keyword, setKeyword] = useState<string>("");

  const isObjctEmpty = (obj: { [key: string]: any }): boolean => {
    return Object.values(obj).every((val) => {
      if (typeof val === "string") {
        return val.trim() === "";
      } else if (Array.isArray(val)) {
        return val.length === 0;
      } else {
        return false;
      }
    });
  };

  const handleSearchFunc = (args: SearchState) => {
    let query;
    if (!isObjctEmpty(args) || keyword) {
      query = "?pg=1";

      for (const [key, value] of Object.entries(args)) {
        if (value.length) {
          if (key === "prefecture" && Array.isArray(value)) {
            const joined = value.join("&prefecture=");
            query += `&prefecture=${joined}`;
          } else {
            query += `&${key}=${value}`;
          }
        }
      }

      if (keyword) {
        query += `&s=${keyword}`;
      }
    }

    return query
      ? navigate(`/facility/list${query}`)
      : navigate("/facility/list");
  };

  useMetaData({
    title: "全国のeスポーツカフェ・施設情報 SELeCT CAFE BASE",
    description:
      "SELeCT CAFE BASEは日本全国のeスポーツ施設・カフェを掲載しています。オフラインでのeスポーツイベント開催場所の検索にもぴったり！エリア、営業時間、利用料金、座席数、PCスペックなど施設の情報をまとめて確認できます。施設・カフェ・店舗様からの掲載依頼も受付中！",
    imgUrl: "",
  });

  return (
    <FacilityTop
      newFacilities={facilities}
      recommends={recommendData}
      recommendText={sentenceData ? sentenceData : ""}
      // reports={[]}
      isLoading={isLoading || isRecommendLoading ? true : false}
      keyword={keyword}
      handleKeyword={(value: string) => setKeyword(value)}
      handleSearchFunc={handleSearchFunc}
      clearSearch={() => {
        setKeyword("");
      }}
      searchArgs={{
        prefecture: [],
        hostEvents: "",
        foodService: "",
        smoking: "",
      }}
    />
  );
};

export default FacilityTopContainer;
